// extracted by mini-css-extract-plugin
module.exports = {"workspace":"workspace_workspace__1pa3J","light":"workspace_light__J032Q","windows":"workspace_windows__1iWjr"};